<template>
    <div class="">


        <template>
            <!-- Abdullah responsive added mx-3  -->
            <div class="row no-gutters py-2 mb-3 ml-md-3 responsive-padding-left">
                <div class="col-md-10 col-sm-12" >
                    <h4 class="atlhr-dashboard-title mt-10">
                        Personal <span class="black-title"></span>
                    <span>
                        <a v-bind:href="$api_url">Dashboard</a>
                        / Loan & Advance / Personal
                    </span>
                </h4>
                </div>
            </div>
        </template>

        <!-- Abdullah responsive added mx-3  -->
        <div class="clearfix row col-12 no-margin ml-md-3 responsive-padding-left custom-mobile-padding-right-zero">
            <div class="ibox col-md-12 p-3 employee-investment-wrapper">
                <div class="" >
                        <div class="row no-gutters pb-2 mb-3">
                            <div class="col-sm-5 company-form-box-title">Loan & Advance Summary</div>
                            <div class="col-sm-7 cursor-pointer text-right company-form-box-title">
                                <button class="btn btn-block btn-secondary tab-button" @click="addNew()"  >Apply For Loan / Advance</button>
                            </div>
                        </div>
                        <b-overlay :show="showoverlay_list" rounded="sm">

                            <div class="employee-table-wrapper table-sticky-height">
                                <table class="employee-list-table dataTable table-overflow table-sticky ess-custom-table table-responsive">
                                    <thead>
                                        <tr class="table-head ">
                                            <td>  <label class="custom-label"><span> Loan/Advance ID </span></label> </td>
                                            <td><label class="custom-label "><span>Type</span></label> </td>
                                            <td> <label class="custom-label "><span>Amount</span></label>   </td>
                                            <td> <label class="custom-label "><span> Deduction Start Month</span></label>  </td>
                                            <td>  <label class="custom-label "><span> Effective Date </span></label>  </td>
                                            <td>  <label class="custom-label "><span>Tenure </span></label>  </td>
                                            <td> <label class="custom-label "><span>Status</span></label> </td>
                                            <td> <label class="custom-label "><span>Action</span></label> </td>
                                        </tr>
                                    </thead>
                                    <template v-if="loans.length > 0">
                                        <tbody>
                                            <tr class="hover-bg table-row" v-for="loan in loans" :key="loan.id">
                                                <td>
                                                    <div class="" v-if="loan.company_loan_id != 'N/A'">{{loan.company_loan_id}}</div>
                                                    <div class="" v-else> Not assigned yet </div>
                                                </td>
                                                <td>
                                                    <div class="">{{loan_types_drop[loan.loan_type]}}</div>
                                                </td>
                                                <td>
                                                    <div class="text-right">{{formatMoney(loan.loan_amount)}}</div>
                                                </td>
                                                <td>
                                                    <div>{{loan.deduction_start_month}}</div>
                                                </td>
                                                <td>
                                                    <div>{{loan.effective_date_of_loan}}</div>
                                                </td>
                                                <td>
                                                    <div>{{loan.loan_tenure}} Month(s)</div>
                                                </td>

                                                <!-- Abdullah responsive commented this  -->
                                                <!-- <td :class="getValueClass(loan_stat_title_2, loan.status)">
                                                    <span>
                                                    {{loan_stat_title_2[loan.status]}}
                                                    </span>
                                                </td> -->

                                                <!-- Abdullah responsive added this  -->
                                                <td class="text-center status-wrapper" :class="loan_stat_title_2[loan.status] ? loan_stat_title_2[loan.status].toLowerCase().replace('/', '-') : ''">
                                                    <span class="leave-status">
                                                        <i class="fa fa-circle mr-1"></i>{{loan_stat_title_2[loan.status]}}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div class="clearfix py-2 text-center position-relative d-flex align-items-center justify-content-end col-sm"  v-if="flg > 0"> <!-- Mustafijur: 19-05-2026 -->
                                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                            <b-button-toolbar class="custom-btn-toolbar">
                                                                <b-button-group class="d-flex flex-column flex-grow-1">

                                                                    <!-- <b-button class="border-0 rounded mb-1" variant="secondary" v-if="loan_stat_title[loan.status] == 'Applied'"  title="Edit Loan" @click="editLoanInfo(loan.id,0,0)">
                                                                        <i class="fas fa-edit"></i>Edit
                                                                    </b-button> -->
                                                                    <b-button variant="outline-secondary" v-if="loan_stat_title[loan.status] == 'Applied'"  title="Edit Loan" @click="editLoanInfo(loan.id,0,0)">
                                                                        <b-icon icon="pencil"></b-icon> Edit
                                                                    </b-button>
                                                                    <!-- <b-button class="border-0 rounded mb-1"  v-if="loan.has_tx==0  && (loan_stat_title[loan.status] == 'Applied')" variant="secondary" title="Delete Loan" @click="showDeleteModal(loan.id)">
                                                                        <i class="fas fa-times"></i>  Delete
                                                                    </b-button> -->

                                                                    <b-button variant="outline-secondary" v-if="loan.has_tx==0  && (loan_stat_title[loan.status] == 'Applied')" title="Delete Loan" @click="showDeleteModal(loan.id)">
                                                                        <b-icon icon="trash"></b-icon> Delete
                                                                    </b-button>
                                                                    <b-button class="border-0 rounded mb-1"  v-if="loan_stat_title[loan.status] == 'Approved' || loan_stat_title[loan.status] == 'Returned' || loan_stat_title[loan.status] == 'Pause/Stopped' " variant="secondary" title="Show Installments" @click="showInstallment(loan)">
                                                                        <i class="fab fa-delicious"></i> Installments
                                                                    </b-button>
                                                                    <b-button class="border-0 rounded mb-1" variant="secondary" title="Transactions" v-if="loan_stat_title[loan.status] != 'Applied'" @click="showLoanTransactions(loan.id,loan)">
                                                                        <i class="fas fa-table"></i> Transactions
                                                                    </b-button>
                                                                </b-button-group>
                                                            </b-button-toolbar>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                    <template v-else>
                                        <tr class="hover-bg table-row">
                                            <td class="cursor-pointer trz_relative text-center" colspan="7">No Application found</td>
                                        </tr>
                                    </template>

                                </table>
                            </div>

                        </b-overlay>
                    </div>
                </div>
            </div>







        <!-- Mustafijur: 19-05-2026: modal -->
        <b-modal id="delete-modal" title="Are you sure you want to delete this Loan/Advance ?" hide-footer centered> <!-- Mustafijur: 19-05-2026 -->
            <!-- <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div> -->
            <div class="border-bottom mb-2">
                <p class="modal-body px-0">Please confirm if you want to delete this entry.</p>
            </div>
                <a href="javascript:void(0);" class="btn btn-primary float-right"  @click="deleteLoan(loan_entity_id)">Delete <span v-if="loading != ''"><img :src="$api_url+'/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp;
            <a href="javascript:void(0);" class="btn btn-primary float-right mr-2" block @click="$bvModal.hide('delete-modal')">Cancel</a>

            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <!-- Mustafijur: 19-05-2026: modal -->

        <b-modal id="bv-modal-loan" size="lg" hide-footer v-bind:title="modal_title">
        <loan-form-front  :flg="flg" :employee_id="this.employee_id" :key="count" :count="count" :loan_id="loan_id" :is_custom="is_custom" :is_status="is_status" :is_front="em_front" v-on:childToParent="updateLoanData"></loan-form-front>
        </b-modal>


        <b-modal id="installment-modal"  hide-footer>
        <template #modal-title>
            <span class="mr-2">Installment Breakdown</span>
            <span :class="getValueClass(loan_stat_title_2, selected_loan.status)">
                <span >
                {{loan_stat_title_2[selected_loan.status]}}
                </span>
            </span>
            <div class="title-sub-text mt-0">{{selected_loan.company_loan_id}}</div>
        </template>
        <div class="row table-head ">
            <div class="col-sm-3 font-weight-bold py-2 text-left">
                Installment #
            </div>
            <div class="col-sm-3 font-weight-bold py-2 text-left">
                EMI Month
            </div>
            <div class="col-sm-3 font-weight-bold py-2 text-left">
                Pay Run Month
            </div>
            <div class="col-sm-3 font-weight-bold py-2 text-right">
                Amount
            </div>
        </div>
        <div class="row table-row hover-bg"  v-for="(row, index) in my_installments" :key="index">
            <div class="col-sm-3 py-2 d-flex text-left border-right">
                <div :style="(row.status==3) ? styleA : styleB" >Installment #{{index+1}}</div>
            </div>
            <div class="col-sm-3 py-2 d-flex text-right border-right" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">
                <div :style="(row.status==3) ? styleA : styleB">{{formatMoney(row.month)}}</div>
            </div>
            <div class="col-sm-3 py-2 d-flex text-right border-right" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">
                <div :style="(row.status==3) ? styleA : styleB">{{formatMoney(row.payrun_month)}}</div>
            </div>
            <div class="col-sm-3 py-2 text-right" v-bind:style="[(row.status==3) ? {styleA} : {styleB}]">
                <div :style="(row.status==3) ? styleA : styleB">{{formatMoney(row.amount)}}</div>
            </div>
        </div>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('installment-modal')">Close</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>
        <b-modal id="bv-modal-loan-transactions-wizard" size="lg" hide-footer>
            <loan-transaction-wizard-front  :key="tx_popup_count" :loan_id="loan_id" :loan_status="selected_loan.status" ></loan-transaction-wizard-front>
        </b-modal>
    </div>
</template>


<script>
    export default{

        mounted() {

        },
        props: ['bn' ,'flg','employee_id'],
        data(){

            return {
                em_front:1,
                loans:[],
                styleA: 'color:#55ce63 !important',
                styleB: 'color:#212529 !important',
                is_status:'',
                loan_stat_title: ["Declined","Applied","Approved","Pause/Stopped","Returned"],
                loan_stat_title_2: ["Declined","Applied","Open","Pause/Stopped","Closed"],
                loan_stat_div: ["text-danger","text-info","text-success","text-muted","text-purple"],
                default_tenure: [0,12,1],
                showoverlay_list : false,
                disableme: false,
                disable_submit :false,
                successmsg:'',
                errormsg:[],
                selected_bank_id:0,
                loading:'',
                loan_title:'',
                amount_title: '',
                showoverlaymodal : false,
                loan_entity_id:'',
                loan_update_status:'',
                loan_type: 1,
                loan_id :0,
                modal_title:"",
                is_custom:0,
                my_installments:[],
                count:0,
                loan_types_drop : ['','Loan','Advance'],
                loan_status:[
                    { value: null, text: "Select..." },
                    { value: "0", text: "Decline" },
                    { value: "1", text: "Applied" },
                    { value: "2", text: "Approve" },
                    { value: "3", text: "Pause/Stop" },
                ],
                loan_type_vals:[
                    { value: "1", text: "Loan" },
                    { value: "2", text: "Advance" },

                ],
                m_lists : [],
                tx_popup_count:0,
                selected_loan:[],
            }
        },
        methods:{

            getValueClass: function (data, key) {
                var strclass = '';
                strclass = 'status-label status-label-' + data[key].toLowerCase().replace('/', '-');

                return strclass;
            },
            showDeleteModal: function(pageflg)
            {
            this.loan_entity_id=pageflg;
            this.$bvModal.show('delete-modal');
            },

            showInstallment: function(loan)
            {
                this.selected_loan = [];
                this.selected_loan = loan;
                if(!this.checkNet()) return false;
                let currentObj = this;
                let formData = new FormData();
                for (let [key, value] of Object.entries(loan))
                {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                }
                this.my_installments = [];
                this.showoverlay = true;
                axios.post(this.$api_url+'/front/loan-advance/installments', formData)
                .then(function (response)
                {
                    this.my_installments = response.data;
                    this.showoverlay = false;
                    this.$bvModal.show('installment-modal');

                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            showLoanTransactions: function(loan_id,loan)
            {
                this.selected_loan = [];
                this.selected_loan = loan;
                this.loan_id = loan_id;
                this.tx_popup_count = this.tx_popup_count + 1;
                this.modal_title = '';
                this.$bvModal.show('bv-modal-loan-transactions-wizard');

            },
            deleteLoan: function(pageflg)
            {

                this.loading='load';

                let formData = new FormData();
                formData.append('loan_id', pageflg);

                axios.post(this.$api_url+'/front/loan-delete', formData)
                    .then(function (response)
                    {
                        this.$bvModal.hide('delete-modal');
                        this.loan_entity_id='';
                        this.loan_update_status = '';
                        this.loading='';
                        this.updateLoanData();
                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },
            updateLoanData: function()
            {
                this.$bvModal.hide('bv-modal-loan');
                this.loan_title = 'Employee Loan/Advance List';
                if(!this.checkNet()) return false;
                let currentObj = this;

                axios.get(this.$api_url+'/front/loan-advance/list' , {
                    params: {

                    }
                }).then(function(response){
                    this.loans = response.data;

                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            updateTransactions()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                axios.get(this.$api_url+'/front/loan-advance/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.updateLoanData();
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            swapComponent: function(component_name)
            {
                //
                let formData = new FormData();
                formData.append('sess', 'subordinate_id');
                axios.post(this.$api_url+'/front/flushsess', formData)
                                .then(function (response)
                                {

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                });


                this.currentComponent = component_name;
                this.$cookies.set("last_clicked_component",component_name);
                this.activeItem = component_name;
            },
            getEmployeePublicData: function()
            {
                if(!this.checkNet()) return false;

                axios.get(this.$api_url+'/front/employee/publicinfo' , {
                    params: {

                    }
                }).then(function(response){
                    this.employee_data = response.data;
                    this.employee_id = this.employee_data.employee_id;

                    if(this.employee_data.pic != '')
                        this.avatarsrc = this.$api_url+'/images/employee/'+ this.employee_data.company_id + '/' + this.employee_data.pic;
                    else
                        this.avatarsrc = this.$api_url+'/images/employee/demo.jpg';

                }.bind(this));
            },
            addNew()
            {
                this.is_custom = 0;
                this.is_status= 0;
                this.loan_id = 0;
                this.count = this.count + 1;
                console.log(this.em_front);
                this.modal_title = "Apply for Loan/Advance";
                this.$bvModal.show('bv-modal-loan');

            },
            // Mustafijur: 24-05-2026: Starts
            // formatMoney: function(amount){
            //     var money = Number(amount);
            //     money = money.toLocaleString();
            //     if(money=='NaN')
            //     money = amount;
            //     else{
            //     if(money.indexOf(".")<0)
            //     money = money+".00";
            //     }
            //     return money;
            // },
            formatMoney: function(amount){
                var money = Number(amount);

                if(this.$atl_company_number_format == 'no')
                {
                    money = Math.round(money);
                    money = money.toLocaleString();
                }
                else
                {
                    money = money.toLocaleString();
                    if(money=='NaN')
                    money = amount;
                    else{
                    if(money.indexOf(".")<0)
                    money = money+".00";
                    }

                }

                return money;
            },
            // Mustafijur: 24-05-2026: Ends
            toMoney: function(amount){
                if(amount !="0")
                {
                    if(!isNaN(amount))
                    {
                        var number = Number(amount);
                        return number;
                    }
                var NumWithoutCommas = amount.replace(/,/g, '');
                var number = Number(NumWithoutCommas).toFixed(2);
                return number;
                }else
                    return amount;
            },
            editLoanInfo(loan_id,is_custom,status)
            {
                this.modal_title = "Edit Loan/Advance";
                this.is_custom = is_custom;
                if(is_custom)
                {
                    this.modal_title = "Manual Payment";
                }
                this.is_status= status;
                this.loan_id = loan_id;
                this.count = this.count + 1;
                this.$bvModal.show('bv-modal-loan');
            },
        },
        created: function()
        {

            this.updateTransactions();
            this.getEmployeePublicData();
        }
    }
</script>
